module.exports = "mutation ($id: ID!, $data: CommentUpdate!) {\n  CommentUpdate(id: $id, data: $data) {\n    id\n    processedBy {\n      name\n    }\n  }\n}\n"